import { Pipe, PipeTransform } from '@angular/core';
import { FormService } from '../services/form.service';
import * as _ from 'lodash';

@Pipe({
  name: 'toPercentage'
})
export class ToPercentagePipe implements PipeTransform {

  constructor(private formService: FormService) {}

  transform(percent: number, decimalPlaces: number): any {
    if (percent == null) {
      return null;
    } else {
      return _.round(percent * 100, +decimalPlaces);
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/pipes/to-percentage.pipe.ts